import {AfterViewInit, Component, EventEmitter, Injector, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {NgxFilterBase} from '../../../ngx-filter-base';
import {Filter} from "../../../../ngx-types";

@Component({
  selector: 'ngx-select-filter',
  templateUrl: '../../../ngx-filter-single-template-base.html',
})
export class NgxSelectFilterComponent extends NgxFilterBase implements OnInit, OnDestroy, AfterViewInit {
  @Input() filter: Filter;
  @Output() changeValue = new EventEmitter<any>();

  constructor(injector: Injector) {
    super(injector);
  }

  get Label1(): string {
    return this.filter?.label;
  }

  Label2: string;

  ngAfterViewInit(): void {
    this.generateComponents(this.filterService.filtersComponent.selectBox, this.filter.options?.selectBoxOptions);
  }
}
